import * as React from "react";
import { AuthContext } from "src/components/context/AuthContext";
import { useEffect } from "react";
import { Redirect } from "react-router-dom";

export const Logout = props => {
  const { signOut, isLoggedIn } = React.useContext(AuthContext);

  useEffect(() => {
    signOut().then(resp => {
      props.history.push("/");
    });
  }, []);

  return !isLoggedIn ? <Redirect to="/" /> : <></>;
};



// WEBPACK FOOTER //
// ./src/pages/logout/Logout.tsx